export class Base64 {
  constructor() {
    this.b64c =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    this.b64u =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
    this.b64pad = '='
  }
  encode(s) {
    const utf8str = unescape(encodeURIComponent(s))
    return this.encodeData(utf8str, utf8str.length, this.b64c)
  }

  decode(data) {
    let dst = ''
    let i
    let a
    let b
    let c
    let d
    for (i = 0; i < data.length - 3; i += 4) {
      a = this.charIndex(data.charAt(i + 0))
      b = this.charIndex(data.charAt(i + 1))
      c = this.charIndex(data.charAt(i + 2))
      d = this.charIndex(data.charAt(i + 3))
      dst += String.fromCharCode((a << 2) | (b >>> 4))
      if (data.charAt(i + 2) !== this.b64pad) {
        dst += String.fromCharCode(((b << 4) & 0xf0) | ((c >>> 2) & 0x0f))
      }
      if (data.charAt(i + 3) !== this.b64pad) {
        dst += String.fromCharCode(((c << 6) & 0xc0) | d)
      }
    }
    dst = decodeURIComponent(escape(dst))
    return dst
  }

  charIndex(c) {
    if (c === '+') {
      return 62
    }
    if (c === '/') {
      return 63
    }
    return this.b64u.indexOf(c)
  }
}

/**
 * Removes whitespace within a string and makes all
 * characters lowercase.
 *
 * @param {String} str
 */
export const handleize = (str) => {
  const newStr = str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
    .replace(/\-\-+/g, '-') // Replaces multiple hyphens by one hyphen
    .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
    .toLowerCase() // To lowercase

  return newStr
}

class MainProduct extends HHBaseElement {
  constructor() {
    super()
    this.variantChangeCallbacks = []
    this._isReadyPromise = new Deferred()
    this.selectCallback = this.selectCallback.bind(this)
    this._bundleSelectCallback = this._bundleSelectCallback.bind(this)
    this.subscriptionPercent =
      this.product.selling_plan_groups[0]?.selling_plans[0]
        ?.price_adjustments[0]?.value ?? 0

    this.shadeSlider = this.querySelector(
      '.swatch-category-slider .shade-slider'
    )
    this.tabs = this.shadeSlider?.querySelectorAll('li')
    this.tabPanel = this.querySelector('.js-swatches-container')
    this.tabSwatches = this.tabPanel?.querySelectorAll('.swatch-element')
    this.tabSwatchesColorButton = this.tabPanel?.querySelectorAll(
      '.swatch-color-button'
    )
    this._initTabA11y = this._initTabA11y.bind(this)
    this._handleTabButton = this._handleTabButton.bind(this)
    this._handleTabButtonKeydown = this._handleTabButtonKeydown.bind(this)
    this._updatePricing = this._updatePricing.bind(this)
    this._updateFixedATC = this._updateFixedATC.bind(this)
    this.registerVariantChangeCallback =
      this.registerVariantChangeCallback.bind(this)
    this.subscriptionSelected = false
    this._showOrHideShopPay = this._showOrHideShopPay.bind(this)

    this.stockNotification = this.querySelectorAll(
      '.single-product-page .atc-container #stock_notification'
    )
    this.fixedAddToCartButton = this.querySelectorAll(
      '.fixed-add-to-cart__button-container .atc-container #add_to_cart'
    )

    this.reviewReadMoreToggles = [
      ...this.querySelectorAll('.js-review-read-more'),
    ]

    this.scrollToReviewsToggles = [
      ...this.querySelectorAll('.js-scroll-to-reviews'),
    ]

    this.scrollToReviews = this.scrollToReviews.bind(this)
    this.revealReadMore = this.revealReadMore.bind(this)

    document.addEventListener(
      'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
      () => {
        this.subscriptionSelected = true
        this.toggleBwp()
      }
    )
    document.addEventListener(
      'AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected',
      () => {
        this.subscriptionSelected = false
        this.toggleBwp()
      }
    )

    this._initTabA11y()
  }

  toggleBwp() {
    const isSubscribed = this.subscriptionSelected
    const bwpButton = this.querySelector('#amzn-buy-now')
    const bwpFrame = document.querySelector('#bwpFrame')
    const divider = document.querySelector('.product-details__divided-line')
    const bwpEnabled =
      bwpFrame && bwpFrame.classList.contains('bwp-widget-loaded')

    if (!bwpEnabled || isSubscribed) {
      if (bwpButton) {
        bwpButton.style.display = 'none'
      }
      if (bwpFrame) {
        bwpFrame.style.display = 'none'
      }
      if (divider) {
        divider.style.display = 'none'
      }

      return
    }

    if (bwpButton) {
      bwpButton.style.display = ''
    }
    if (bwpFrame) {
      bwpFrame.style.display = ''
    }
    if (divider) {
      divider.style.display = ''
    }
  }

  _initTabA11y() {
    this.tabs?.forEach((tab) => {
      let button = tab.querySelector('button')

      button.addEventListener('click', (e) => {
        this._handleTabButton(e.target)
      })

      button.addEventListener('keydown', (e) => {
        this._handleTabButtonKeydown(e)
      })
    })
  }

  _handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }

  _handleTabButton(target) {
    // Clear active state
    let tabButtons = [...this.shadeSlider.querySelectorAll('button')]

    tabButtons.forEach((button) => {
      button.classList.remove('active')
      button.setAttribute('tabindex', -1)
      button.setAttribute('aria-selected', 'false')
    })

    // Set active state
    target.classList.add('active')
    target.setAttribute('tabindex', 0)
    target.setAttribute('aria-selected', 'true')
    target.focus()
  }

  _handleTabButtonKeydown(e) {
    let newButton
    if (e.code === 'ArrowLeft') {
      newButton = e.target
        .closest('li')
        ?.previousElementSibling?.querySelector('button')
    } else if (e.code === 'ArrowRight') {
      newButton = e.target
        .closest('li')
        ?.nextElementSibling?.querySelector('button')
    }

    if (newButton) {
      this._handleTabButton(newButton)
    }
  }

  get selectedVariant() {
    const selectedVariant = this.querySelector('.selected-variant')

    if (selectedVariant) {
      const matchingVariant = this.product.variants.find(
        (v) => String(v.id) === String(selectedVariant.value)
      )

      return matchingVariant ?? this.product.variants[0]
    }

    return this.product.variants[0]
  }

  get originalPrice() {
    return Shopify.formatMoney(
      this.selectedVariant.price,
      Shopify.currency.active == 'GBP' ? '£{{amount}}' : undefined
    )
  }

  get subscriptionPrice() {
    const subscriptionSelected = document.querySelector(
      'og-optin-button[subscribed]'
    )

    if (subscriptionSelected && subscriptionSelected.__subscribed) {
      const matchingVariant = this.product.variants.find(
        (v) => String(v.id) === String(subscriptionSelected.__subscribed.id)
      )

      if (matchingVariant) {
        const sellingPlan = matchingVariant.selling_plan_allocations.find(
          (spa) =>
            String(spa.selling_plan_id) ===
            String(subscriptionSelected.__subscribed.frequency)
        )

        if (sellingPlan) {
          return Shopify.formatMoney(
            sellingPlan.price,
            Shopify.currency.active == 'GBP' ? '£{{amount}}' : undefined
          )
        }
      }
    }

    return this.originalPrice
  }

  get productId() {
    return this.getAttribute('product-id')
  }

  get product() {
    return JSON.parse(
      new Base64().decode(
        this.querySelector(`#main-product-data-${this.productId}`).innerText
      )
    )
  }

  get currency() {
    return this.getAttribute('currency')
  }

  get variantType() {
    return this.getAttribute('variant-type')?.trim()
  }

  get withHistoryState() {
    return Boolean(this.getAttribute('with-history'))
  }

  get stockNotificationEnabled() {
    return Boolean(this.getAttribute('stock-notification'))
  }

  get variantStock() {
    return window[`variantStock${this.product.id}`]
  }

  get atcPrice() {
    const subscriptionSelected = document.querySelector(
      'og-optin-button[subscribed]'
    )

    return subscriptionSelected ? this.subscriptionPrice : this.originalPrice
  }

  get isShowWaitlist() {
    return this.dataset.showWaitlist === 'true'
  }

  get alwaysShowWaitlist() {
    return Boolean(this.getAttribute('show-waitlist-always'))
  }

  stockNotificationHide() {
    if (this.stockNotificationEnabled) {
      this.stockNotification.forEach((button) => button.classList.add('hidden'))
      this.fixedAddToCartButton.forEach((button) =>
        button.classList.remove('hidden')
      )
    }
  }

  stockNotificationShow() {
    if (this.stockNotificationEnabled) {
      this.stockNotification.forEach((button) =>
        button.classList.remove('hidden')
      )
      this.fixedAddToCartButton.forEach((button) =>
        button.classList.add('hidden')
      )
    }
  }

  revealReadMore(e) {
    let fullMessage = e.target.dataset.body
    e.target.previousElementSibling.innerHTML = fullMessage
    e.target.classList.add('hidden')
  }

  clearSelectedSizes() {
    let allSelectedSizes = [
      ...document.querySelectorAll('.size-select-container.selected'),
    ]
    allSelectedSizes.forEach((item) => item.classList.remove('selected'))
  }

  clearSelectedColors() {
    let allSelectedSwatches = [
      ...document.querySelectorAll('.color-select-container.selected'),
    ]
    allSelectedSwatches.forEach((item) => item.classList.remove('selected'))
  }

  handleSelectedVariantChange(variant) {
    this.variantChangeCallbacks.forEach((cb) => cb?.(variant))
  }

  registerVariantChangeCallback(cb) {
    this.variantChangeCallbacks.push(cb)
  }

  scrollToReviews() {
    let target = document.querySelector('#okendo-reviews')
    const targetPosition = target.offsetTop

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    })

    document.querySelector('.okendo-reviews-widget')?.focus()
  }

  _bundleSelectCallback(variant) {
    this.handleSelectedVariantChange(variant)
    this._updateBuyWithPrime(variant)
    this._updateVariantInput(variant)
    this._updateViewMoreLink(variant)

    // Update variant dropdowns
    variant.options.forEach((option, index) => {
      const variantDropdown = this.querySelector(
        `variant-dropdown[data-option-target='option${index + 1}']`
      )
      if (variantDropdown) {
        variantDropdown.variantName = option
      }
    })

    this._updatePricing(variant)
    this._updateSellFastBadges(variant)
    this._updateFixedATC(variant)
    this._showOrHideShopPay(variant)
  }

  selectCallback(variant, selector) {
    if (variant) {
      this.handleSelectedVariantChange(variant)
      this._updateBuyWithPrime(variant)
      if (
        selector.domIdPrefix === 'size-variants' ||
        selector.domIdPrefix === 'size-variants-quick'
      ) {
        // size logic

        // 1.clear selected size and select new size
        this.clearSelectedSizes()
        let newSelectedSize = this.querySelector(
          `.options-wrapper li[data-value="${handleize(
            variant.title
          )}"] .size-select-container`
        )
        newSelectedSize.classList.add('selected')

        let variantDropdowns = this.querySelectorAll('variant-dropdown')
        variantDropdowns.forEach((dropdown) =>
          dropdown.setAttribute('variant', variant.id)
        )
      } else if (
        selector.domIdPrefix === 'general-variants' ||
        selector.domIdPrefix === 'general-variants-quick'
      ) {
        let variantDropdowns = this.querySelectorAll('variant-dropdown')
        variantDropdowns.forEach((dropdown) =>
          dropdown.setAttribute('variant', variant.id)
        )
      } else {
        // update color dropdowns sort logic
        let variantDropdowns = this.querySelectorAll('variant-dropdown')
        variantDropdowns.forEach((dropdown) =>
          dropdown.setAttribute('variant', variant.id)
        )

        // // 3. Update selected color variant
        this.clearSelectedColors()

        let variantMapValue = this.variantMap.filter(
          (mappedVariant) => mappedVariant.optionGenName === variant.title
        )?.[0]?.name

        let newSelectedItem = this.querySelector(
          `.options-wrapper div[data-value='${handleize(
            variantMapValue
          )}'] .color-select-container`
        )

        newSelectedItem?.classList.add('selected')

        // Apply to VTO
        if (
          typeof this.querySelector('virtual-try-on')
            ?._handleSelectedVariantChange === 'function'
        ) {
          this.querySelector('virtual-try-on')._handleSelectedVariantChange()
        }
      }

      this._updateVariantInput(variant)
      this._updateViewMoreLink(variant)

      // 2. Update product-gallery
      let productGalleries = this.querySelectorAll('product-gallery')
      productGalleries.forEach((gallery) =>
        gallery.setAttribute('variant', variant.title)
      )

      // 4. Update pricing
      this._updatePricing(variant)

      // 5. Update Selling Fast badge based on variant inventory - there are currently two instances of the badge
      this._updateSellFastBadges(variant)
    }

    // 6. Update fixed atc
    this._updateFixedATC(variant)

    // 7. Update Shop Pay visibility
    this._showOrHideShopPay(variant)
  }

  _showOrHideShopPay(variant) {
    const shopPayContainer = this.querySelector('[data-shop-pay-container]')
    if (!shopPayContainer) return

    if (variant.available) {
      shopPayContainer.classList.remove('dynamic-checkout-wrapper--hidden')
    } else {
      shopPayContainer.classList.add('dynamic-checkout-wrapper--hidden')
    }
  }

  _updateVariantInput(variant) {
    const variantInput = this.querySelector('.selected-variant')
    variantInput.value = variant.id
  }

  _updateViewMoreLink(variant) {
    let viewMoreLink = this.querySelector('.view-full-details-link a')
    if (viewMoreLink) {
      let newViewMoreLink = new URL(viewMoreLink.href)
      newViewMoreLink.searchParams.set('variant', variant.id)
      viewMoreLink.href = newViewMoreLink?.href
    }
  }

  _updatePricing(variant) {
    let variantPrice = variant.price / 100
    let compareVariantPrice = variant?.compare_at_price / 100

    let priceParent = this.querySelector('.single-product .price ')
    let normalPriceContainer = this.querySelector(
      '.single-product .price__regular'
    )
    let priceElement = this.querySelector(
      '.single-product [data-variant-price]'
    )
    let salePriceContainer = this.querySelector('.single-product .price__sale ')
    let addToCartButton = this.querySelectorAll(
      '.single-product .atc-container #add_to_cart'
    )
    let addToCartButtonTitle = this.querySelectorAll(
      '.single-product .atc-container #add_to_cart span:nth-child(1)'
    )
    let addToCartButtonIcon = this.querySelectorAll(
      '.single-product .atc-container #add_to_cart svg'
    )

    let nonAvailableClass = atcStatusTitle.outOfStockClass
    let nonAvailableTitle = atcStatusTitle.outOfStock
    if (this.alwaysShowWaitlist || this.isShowWaitlist) {
      nonAvailableClass = atcStatusTitle.notifyMeClass
      nonAvailableTitle = atcStatusTitle.notifyMe
    }

    if (variant.compare_at_price) {
      // reveal compare price
      priceParent.classList.add('price--on-sale')
      normalPriceContainer.classList.add('hidden')
      salePriceContainer.classList.remove('hidden')

      // set new variant price
      let compareVariantDiv = salePriceContainer.querySelector(
        '.price-item--regular'
      )
      let priceDiv = salePriceContainer.querySelector('.price-item--sale')

      variantPrice = variantPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: this.currency,
      })
      compareVariantPrice = compareVariantPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: this.currency,
      })

      compareVariantDiv.innerHTML = compareVariantPrice
      priceDiv.innerHTML = variantPrice
      priceElement.innerHTML = variantPrice

      if (variant.available && !this.alwaysShowWaitlist) {
        addToCartButton.forEach((button) => {
          button.classList.remove(...nonAvailableClass)
          button.classList.add(atcStatusTitle.addToBagClass)
          button.removeAttribute('data-target')
        })
        addToCartButtonIcon.forEach((icon) => icon.classList.remove('hidden'))
        addToCartButtonTitle.forEach(
          (title) => (title.innerHTML = atcStatusTitle.addToBag)
        )
        addToCartButton.forEach((button) => (button.disabled = false))
        this.stockNotificationHide()
      } else {
        addToCartButton.forEach((button) => {
          button.classList.remove(atcStatusTitle.addToBagClass)
          button.classList.add(...nonAvailableClass)
          button.setAttribute('data-target', atcStatusTitle.targetID)
        })
        addToCartButtonIcon.forEach((icon) => {
          if (!icon.classList.contains('hidden')) icon.classList.add('hidden')
        })
        addToCartButtonTitle.forEach(
          (title) => (title.innerHTML = nonAvailableTitle)
        )
        if (!this.isShowWaitlist) {
          addToCartButton.forEach((button) => (button.disabled = true))
        }
        this.stockNotificationShow()
      }
    } else {
      // hide compare price
      priceParent.classList.remove('price--on-sale')
      normalPriceContainer.classList.remove('hidden')
      salePriceContainer.classList.add('hidden')

      // set new variant price
      let priceDiv = normalPriceContainer.querySelector('.price-item--regular')
      variantPrice = variantPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: this.currency,
      })

      priceDiv.innerHTML = variantPrice
      priceElement.innerHTML = variantPrice

      if (variant.available && !this.alwaysShowWaitlist) {
        addToCartButton.forEach((button) => {
          button.classList.remove(...nonAvailableClass)
          button.classList.add(atcStatusTitle.addToBagClass)
          button.removeAttribute('data-target')
        })
        addToCartButtonIcon.forEach((icon) => icon.classList.remove('hidden'))
        addToCartButtonTitle.forEach(
          (title) => (title.innerHTML = atcStatusTitle.addToBag)
        )
        addToCartButton.forEach((button) => (button.disabled = false))
        this.stockNotificationHide()
      } else {
        addToCartButton.forEach((button) => {
          button.classList.remove(atcStatusTitle.addToBagClass)
          button.classList.add(...nonAvailableClass)
          button.setAttribute('data-target', atcStatusTitle.targetID)
        })
        addToCartButtonIcon.forEach((icon) => {
          if (!icon.classList.contains('hidden')) icon.classList.add('hidden')
        })
        addToCartButtonTitle.forEach(
          (title) => (title.innerHTML = nonAvailableTitle)
        )
        if (!this.isShowWaitlist) {
          addToCartButton.forEach((button) => (button.disabled = true))
        }
        this.stockNotificationShow()
      }
    }
  }

  _updateSellFastBadges(variant) {
    let sellFastBadges = [
      ...this.querySelectorAll('.single-product-page .selling-fast-container'),
    ]

    if (sellFastBadges.length > 0) {
      let variantInventory = parseFloat(this.variantStock?.[variant.id]) || 0
      let sellFastThreshold = parseFloat(
        this.querySelector('.single-product-page .selling-fast-container')
          .dataset.threshold
      )

      if (variantInventory <= sellFastThreshold) {
        sellFastBadges.forEach((badge) => badge.classList.remove('hidden'))
      } else {
        sellFastBadges.forEach((badge) => badge.classList.add('hidden'))
      }
    }
  }

  _updateFixedATC(variant) {
    let fixedAtc = this.querySelector('.fixed-add-to-cart__container')

    if (fixedAtc && window.innerWidth > 992) {
      let fixedVariantTitle = this.querySelector(
        '.fixed-add-to-cart__container .current-variant__title'
      )

      let doesProductHaveColor =
        [...this.querySelectorAll('.swatch-element.color')].length > 0

      if (variant) {
        fixedVariantTitle.innerText = variant.title

        if (doesProductHaveColor) {
          let currentVariantShade = this.querySelector(
            '.fixed-add-to-cart__container .swatch-color-span'
          )
          let newVariantColorEl = this.querySelector(
            'span[data-tooltip="' + handleize(variant.title) + '"] button'
          )

          if (newVariantColorEl) {
            currentVariantShade.style.backgroundColor =
              newVariantColorEl.style.backgroundColor
          }
        }
      }
    }
  }

  _updateBuyWithPrime(variant) {
    try {
      if (!variant || !variant.sku) {
        return
      }

      const target = document.querySelector('#amzn-buy-now')
      if (target) {
        target.dataset.sku = variant.sku
      }

      if (window.bwp) {
        window.bwp.updateWidget(variant.sku)
      }
    } catch (error) {}
  }

  initBundleOptionSelector() {
    this.optionsSelector = new Shopify.OptionSelectors(
      `product-${this.productId}-bundle-variant-select`,
      {
        product: this.product,
        onVariantSelected: this._bundleSelectCallback,
        enableHistoryState: this.withHistoryState,
      }
    )
  }

  initOptionSelector() {
    if (this.variantType === 'none' || !this.variantType) {
      return
    }

    this.optionsSelector = new Shopify.OptionSelectors(this.variantType, {
      product: this.product,
      onVariantSelected: this.selectCallback,
      enableHistoryState: this.withHistoryState,
    })

    let selector = this.querySelector('.single-option-selector')
    let options = [...selector.querySelectorAll('option')]

    let liquidVariants = this.querySelector('.hidden-variants')
    let liquidOptions = [...liquidVariants.querySelectorAll('option')]

    let rawVariants = this.product.variants

    let uniqueSelector = options.map((option) => {
      let newObject = {
        value: rawVariants.find((v) => v.title === option.innerText)?.id,
        name: liquidOptions.find((o) => o.innerText === option.innerText)
          ?.innerText,
        optionGenName: option.value,
      }

      return newObject
    })

    this.variantMap = uniqueSelector
  }

  disconnectedCallback() {
    this.atcPriceObserver.disconnect()
    this.subscriptionObserser.disconnect()

    this.scrollToReviewsToggles.forEach((toggle) => {
      toggle.removeEventListener('click', this.scrollToReviews)
    })
    this.reviewReadMoreToggles.forEach((toggle) =>
      toggle.removeEventListener('click', this.revealReadMore)
    )
  }

  connectedCallback() {
    if (this.product.type.toLowerCase() === 'bundle') {
      this.initBundleOptionSelector()
    } else {
      this.initOptionSelector()
    }

    this.triggerEvent('main-product::ready')
    this._isReadyPromise.resolve()

    this.scrollToReviewsToggles.forEach((toggle) => {
      toggle.addEventListener('click', this.scrollToReviews)
    })
    this.reviewReadMoreToggles.forEach((toggle) =>
      toggle.addEventListener('click', this.revealReadMore)
    )
  }

  get isReadyPromise() {
    return this._isReadyPromise.promise
  }
}

window.customElements.define('main-product', MainProduct)
